import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export function ExceptionDialog({ open, onOpenChange, txn, options, onDone }) {
  const [type, setType] = useState("");
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!type) return toast.error("Select an exception type");
    if (!reason.trim()) return toast.error("An exception reason is required");
    setSaving(true);
    try {
      await api.post(`/transactions/${txn.id}/exception`, { exception_type: type, exception_reason: reason });
      toast.success("Exception recorded");
      setType(""); setReason("");
      onOpenChange(false);
      onDone?.();
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border" data-testid="exception-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Report Exception — {txn?.kin_number}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <label className="text-xs uppercase tracking-wide text-muted-foreground">Exception Type</label>
            <Select value={type} onValueChange={setType}>
              <SelectTrigger className="mt-1" data-testid="exception-type-select"><SelectValue placeholder="Select a reason" /></SelectTrigger>
              <SelectContent>
                {options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="text-xs uppercase tracking-wide text-muted-foreground">Explanation (required)</label>
            <Textarea className="mt-1" rows={3} value={reason} onChange={(e) => setReason(e.target.value)}
              placeholder="Describe the issue..." data-testid="exception-reason-input" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button variant="destructive" onClick={submit} disabled={saving} data-testid="exception-submit-btn">Save Exception</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default ExceptionDialog;
